import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import Index from "@/views/Index.vue";
import IndexLogin from "@/views/login/index.vue";

const routes = [
    {
        path: '/home',
        name: 'home',
        component: Index,
        meta: { title: '首页' }
    },
    {
        path: '/login',
        name: 'login',
        component: IndexLogin,
        meta: { title: '登录' }
    },
    {
        path: '/',
        redirect: '/login'
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

// 挂载路由守卫
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        if (store.state.siteInfo && store.state.siteInfo.webTitleSuffix) {
            document.title = to.meta.title + store.state.siteInfo.webTitleSuffix;
        } else {
            document.title = to.meta.title;
        }
    }
    next();
});

export default router;
